import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cargo_page_list = _resolveComponent("cargo-page-list")!

  return (_openBlock(), _createBlock(_component_cargo_page_list, {
    menuTab: _ctx.menuTab,
    list: _ctx.list
  }, null, 8, ["menuTab", "list"]))
}